import app from '../app';

// todo: Миша, где описание? :)
app.factory('adListenerService', ['$rootScope', ($rootScope) => {
    const defaultGroupName = 'default';
    let groupsOfWatchers = {};

    let ad;
    const provideAd = adGetter => {
        $rootScope.$watch(adGetter, newAd => {
            ad = newAd;
        });
    };

    const wrapOneExpression = (expression) => () => {
        try {
            return expression(ad);
        } catch (e) {
            return undefined;
        }
    };

    const wrapArrayOfExpressions = (expressions) => {
        return expressions.map(expression => wrapOneExpression(expression));
    };

    const wrapExpression = (expression) => {
        return Array.isArray(expression) ? wrapArrayOfExpressions(expression) :wrapOneExpression(expression);
    };

    const $watch = (expression, ...params) => {
        return $rootScope.$watch.apply($rootScope, [wrapExpression(expression), ...params]);
    };

    const $watchGroup = (arrayOfExpressions, ...params) => {
        return $rootScope.$watchGroup.apply($rootScope, [wrapExpression(arrayOfExpressions), ...params]);
    };

    const getWatchers = (groupName = defaultGroupName) => {
        return groupsOfWatchers[groupName] || []
    };

    const appendWatcherToGroup = (watcher, groupName = defaultGroupName) => {
        groupsOfWatchers = updateGroupWatchers(groupsOfWatchers, watcher, groupName);
        return () => {
            const withoutThisWatcher = getWatchers(groupName).filter(item => item !== watcher);
            groupsOfWatchers = {
                ...groupsOfWatchers,
                [groupName]: withoutThisWatcher
            };
            watcher();
        };
    };

    const stopWatchers = (groupName = defaultGroupName) => {
        const watchers = getWatchers(groupName).reduce((res, watcher) => {
            if (angular.isFunction(watcher)) {
                watcher();
            } else {
                res.push(watcher);
            }
            return res;
        }, []);
        groupsOfWatchers = setGroupWatchers(groupsOfWatchers, watchers, groupName);
    };

    const hasWatchers = (groupName = defaultGroupName) => {
        return getWatchers(groupName).length > 0;
    };

    const updateGroupWatchers = (groupsOfWatchers, watcher, groupName = defaultGroupName) => ({
        ...groupsOfWatchers,
        [groupName]: [
            ...getWatchers(groupName),
            watcher
        ]
    });

    const setGroupWatchers = (groupsOfWatchers, watchers, groupName = defaultGroupName) => ({
        ...groupsOfWatchers,
        [groupName]: watchers
    });

    const createGroup = (groupName) => {
        groupsOfWatchers = setGroupWatchers(groupsOfWatchers, [], groupName);

        return {
            getWatchers: () => getWatchers(groupName),
            stopWatchers: () => stopWatchers(groupName),
            hasWatchers: () => hasWatchers(groupName),
            $watch: (...watcherParams) => appendWatcherToGroup($watch(...watcherParams), groupName),
            $watchGroup: (...watcherParams) => appendWatcherToGroup($watchGroup(...watcherParams), groupName),
        };
    };

    const getAd = () => ad;

    return {
        provideAd,
        getAd,
        createGroup,
        ...createGroup(defaultGroupName)
    };
}]);
